import { FIELD_KEYS } from 'constants/materialAssessment';

import TableAnalyzeRow from './components/TableAnalyzeRow/TableAnalyzeRow';
import TableHeader from './components/TableHeader/TableHeader';

import type ITableAnalyze from './interfaces/ITableAnalyze';

import styles from './scss/TableAnalyze.module.scss';

function TableAnalyze({
  items,
  headCells,
  headCellsMiniTable,
  maId,
  vcmId,
  onSortChange,
  orderBy,
  locationsCountries,
  refreshAffectedToken,
}: Readonly<ITableAnalyze>) {
  const headCellsMiniTableFiltered = headCellsMiniTable.filter((cell) => cell.id !== FIELD_KEYS.VALUE_CHAIN);

  return (
    <div className={styles.root}>
      <TableHeader headCells={headCells} onSortChange={onSortChange} orderBy={orderBy} />
      <div className={styles.tableBodyScroll} aria-label="Analysis table body">
        <div className={styles.tableBody}>
          {items.map((item) => (
            <TableAnalyzeRow
              key={item.id}
              item={item}
              headCells={headCells}
              headCellsMiniTableFiltered={headCellsMiniTableFiltered}
              locationsCountries={locationsCountries}
              maId={maId}
              vcmId={vcmId}
              orderBy={orderBy}
              refreshAffectedToken={refreshAffectedToken}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default TableAnalyze;
